<template>
  <div class="terms-and-conditions">
    <h2>Terms and Conditions</h2>
    <p>
      Welcome to Passguard9000. By using this application, you agree to abide by
      the following terms and conditions:
    </p>
    <ul>
      <li>
        <strong>Usage:</strong> This application is provided as-is, and we are
        not responsible for any data loss or misuse of the application.
      </li>
      <li>
        <strong>Privacy:</strong> Your data remains local to your device. We do
        not collect or store any of your personal information on our servers.
      </li>
      <li>
        <strong>Ownership:</strong> You own your encrypted data. It is your
        responsibility to maintain and back up your data securely.
      </li>
      <li>
        <strong>Modifications:</strong> We reserve the right to modify or
        discontinue features without prior notice.
      </li>
      <li>
        <strong>Liability:</strong> Passguard9000 is not liable for any loss or
        damage resulting from using this application.
      </li>
    </ul>
    <p>
      For any questions regarding these terms, feel free to
      <a>support@passguard9000.com</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "TermsAndConditionsPage",
};
</script>

<style scoped>
.terms-and-conditions {
  padding: 2rem;
  line-height: 1.6;
  color: #333;

  h2 {
    font-size: 2rem;
    color: var(--primary-color);
    margin-bottom: 1rem;
  }

  ul {
    padding-left: 1.5rem;
    margin: 1rem 0;
    list-style: disc;
  }

  li {
    margin-bottom: 0.5rem;
  }

  a {
    color: var(--primary-color);
    text-decoration: underline;
  }
}
</style>
